import { render, staticRenderFns } from "./PTableExtend.vue?vue&type=template&id=120c056d&scoped=true&"
import script from "./PTableExtend.vue?vue&type=script&lang=ts&"
export * from "./PTableExtend.vue?vue&type=script&lang=ts&"
import style0 from "./PTableExtend.vue?vue&type=style&index=0&id=120c056d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c056d",
  null
  
)

export default component.exports